// GA4 conversion tracking for the signup -> payment acquisition funnel.
//
// IMPORTANT: GA must load ONLY on logged-out acquisition pages (signup flow +
// payment-success). It must NOT load on /login, the dashboard, or any authenticated
// product page, or it floods the marketing GA4 property with customer usage.
// See docs/GA4_App_Handoff_app.easycheckpro.com.md for the full handoff.

export const GA_MEASUREMENT_ID = 'G-6LE6LP2RFZ';

let gaLoaded = false;

// Loads GA4 once. Safe to call on every acquisition page mount.
export function loadGA() {
  if (gaLoaded || typeof window === 'undefined') return;

  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return; // never track in dev

  // Honor the core rule: if the visitor is an authenticated customer, GA must not load.
  try {
    if (window.localStorage && window.localStorage.getItem('easyCheckToken')) return;
  } catch (e) {
    // localStorage may be unavailable (privacy mode) — fall through and load GA.
  }

  gaLoaded = true;

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    // MUST match the marketing site exactly — enables cross-domain session stitching.
    linker: { domains: ['easycheckpro.com', 'app.easycheckpro.com'] },
  });
}

export function trackEvent(name, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}
